import { getCodeDictionaries, getDictionaryAirports } from '@/rest/dictionary'

export default {
  state: () => ({
    dictionaryAirports: null,
    flightCodes: [],
    vehicleTypes: []
  }),
  getters: {
    dictionaryAirports: (state) => state.dictionaryAirports || {},
    hasDictionaryEntries: (state) => (name) => {
      return state[name].length > 1
    }
  },
  mutations: {
    setDictionaryAirports (state, payload) {
      state.dictionaryAirports = payload
    },
    setCodeDictionaries (state, payload) {
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    }
  },
  actions: {
    async getDictionaries ({ commit }) {
      const [airports, codes] = await Promise.all([
        getDictionaryAirports(),
        getCodeDictionaries()
      ])

      if (airports) {
        commit('setDictionaryAirports', airports)
      }

      if (codes) {
        commit('setCodeDictionaries', codes)
      }
    },
    initialize ({ rootGetters, dispatch }) {
      if (!rootGetters.isAuthorized) {
        return
      }

      dispatch('getDictionaries')
      import.meta.env.DEV && console.log('initialized store – dictionary')
    }
  }
}
